// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B6CEr","question":"styles_question__77cxI","inputVisibleButton":"styles_inputVisibleButton__3Nhj-","note":"styles_note__3Ekkp"};